export default {
  deleteConfirm: 'Are you sure you want to delete this service?',
  registrationSuccessHeader: 'Registration was successful',
  registrationSuccessContent: 'You can log in now. A verification email has been sent to your email box. Without verification of your email address, you will not have access to some features.',
  switchTooltip: 'Click here to select a company/service or add service'
}



// WEBPACK FOOTER //
// ./src/i18n/en/messages.js